<template>
	<div class="editor">
		<div class="head">
			<h3>Szerkesztő</h3>
		</div>
		<div class="card">

			<div v-if="type == 'presentation'">
				<div class="row">
					<div class="col-xs-12 col-md-8">
						<md-input-container>
							<label>Cím</label>
							<md-input v-model="form.title"></md-input>
						</md-input-container>
					</div>
					<div class="col-xs-12 col-md-4">
						<md-checkbox v-model="form.isSection">Szekció</md-checkbox>
						<md-checkbox v-if="form.isSection" v-model="form.displayHours">Óra és perc kijelzése</md-checkbox>
					</div>
				</div>
				<!--
				<md-input-container>
					<label>Szervező</label>
					<md-input v-model="form.origin"></md-input>
				</md-input-container>
				<md-input-container>
					<label>Kategória</label>
					<md-input v-model="form.category"></md-input>
				</md-input-container>
				-->
				
				<img :src="form.image" class="formImage">
				<div class="row">
					<div class="col-xs-12 col-md-8">
						<md-input-container>
						<label>Kép (link)</label>
						<md-input v-model="form.image"></md-input>
						</md-input-container>		
					</div>
					<div class="col-xs-12 col-md-4">
						<input type="file" @change="uploadImage" accept="image/*">
					</div>
				</div>			
    			<md-progress v-if="uploading" :md-indeterminate="true"></md-progress>

				<md-input-container>
					<label>Előadók</label>
					<md-input v-model="form.lecturerNames"></md-input>
				</md-input-container>
				<p>
					Az előadókat vesszővel elválasztva kell felsorolni.
				</p>
				<md-input-container>
					<label>Leírás</label>
					<ckeditor v-model="form.description" :config="ckeditor"></ckeditor>
				</md-input-container>
			</div>

			<div v-if="type == 'lecturer'">
				<md-input-container>
					<label>Név</label>
					<md-input v-model="form.name"></md-input>
				</md-input-container>
				<md-input-container>
					<label>Titulus</label>
					<md-input v-model="form.title"></md-input>
				</md-input-container>
				<md-input-container>
					<label>Cég</label>
					<md-input v-model="form.origin"></md-input>
				</md-input-container>
				<md-input-container>
					<label>Kép (link)</label>
					<md-input v-model="form.image"></md-input>
				</md-input-container>
				<md-input-container>
					<label>Bemutatkozás</label>
					<ckeditor v-model="form.description" :config="ckeditor"></ckeditor>
				</md-input-container>
			</div>

			<div class="block dates" v-if="type == 'presentation'">
				<h4>Időpontok</h4>

				<!--
				<md-input-container>
					<label>-tól</label>
					<md-input v-model="form.fromDate"></md-input>
				</md-input-container>
				<md-input-container>
					<label>-ig</label>
					<md-input v-model="form.toDate"></md-input>
				</md-input-container>
				-->

				<date-picker class="date-picker" :date="form.fromDate" :option="option"></date-picker>
				<span>-tól</span>
				<date-picker class="date-picker" :date="form.toDate" :option="option"></date-picker>
				<span>-ig</span>
				<md-input-container>
					<label>Időtartam (perc)</label>
					<md-input v-model="form.duration"></md-input>
				</md-input-container>
				A következő új előadás szerkesztésénél az előző előadás időpontjának vége az alapértelmezett kezdő időpont.
			</div>

			<div class="block attachments">
				<h4>Csatolmányok, kapcsolati adatok</h4>
				<attachment-block :attachments="form.attachments"></attachment-block>
			</div>

			<div class="block lecturers" v-if="type == 'presentation'">
				<h4>Szülő szekció</h4>
				<md-select v-model="form.section" class="col-md-12">
					<md-option v-for="pres in presentations" :value="pres.fireId">{{pres.title}}</md-option>
				</md-select>
				Bármelyik előadás választható egy előadás szekciójaként. A következő új előadás szerkesztésénél az előző előadás szekciója kerül használatra.
			</div>

			
			<div class="block lecturers" v-if="type == 'presentation'">
				<h4>Előadók</h4>
				<div v-for="(lecturer, index) in form.lecturers" class="row">
					<md-select v-model="form.lecturers[index]" class="col-md-10">
						<md-option v-for="lect in lecturers" :value="lect.value">{{lect.label}}</md-option>
					</md-select>
					<p class="col-md-2"><a v-on:click="removeLecturer(index)"><md-icon>remove_circle_outline</md-icon></a></p>
				</div>
				<md-button class="md-primary" v-on:click.native="form.lecturers.push({})">Előadó hozzáadása</md-button>
			</div>
		

			<div class="block location" v-if="type == 'presentation'">
				<h4>Helyszín</h4>
				<div class="row">
					<div>
					  <md-radio v-for="loc in locations" v-model="form.location.fireId" :md-value="loc.fireId">{{loc.name}}</md-radio>
					</div>
				</div>
			</div>

			<div class="actions">
				<md-checkbox v-model="form.closed">Csak cím mutatása</md-checkbox>
				<md-checkbox v-model="form.hidden">Teljes elrejtés</md-checkbox>
				<md-button class="md-raised md-warn" v-on:click.native="remove()">Törlés</md-button>
				<md-button class="md-raised md-accent" v-on:click.native="save()">Mentés</md-button>
			</div>
		</div>
		<!--{{form}}-->
	</div>
</template>

<script>
	import Vue from 'vue'
	import FirebaseDBService from '../../services/FirebaseDBService'
	import ConfliveHelperService from '../../services/ConfliveHelperService'
	import moment from 'moment'
	import datePicker from 'vue-datepicker'
	import _ from 'lodash'
	import Ckeditor from "vue-ckeditor2";

	var lastSection;
	var lastDate;

	function initalForm(){
		return{
			name: "",
			title: "",
			image: "",
			origin: "",
			description: "",
			isSection: false,
			displayHours: true,
			section: " ",
			fromDate: {time: moment().format('YYYY-MM-DD HH:mm')},
			toDate: {time: moment().format('YYYY-MM-DD HH:mm')},
			duration: 60,
			attachments: [],
			lecturers: [],
			questions: [],
			hidden: false,
			location: {}
		}
	};

	export default {
		components: {
			'date-picker': datePicker,
			'attachment-block': require('./AttachmentBlock'),
			Ckeditor
		},
		data(){
			return {
				type: 'presentation',
				form: initalForm(),
				option: {
					type: 'min',
					week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
					month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
					format: 'YYYY-MM-DD HH:mm',
					placeholder: 'Mikor?'
				},
				uploading: false,
				presentations: [],
				lecturers: [],
				locations: [],
				ckeditor: require('../../config.js').default.ckeditor
			}
		},
		watch: { 
      		"form.duration": function(newVal, oldVal) {
      			if(newVal != oldVal){
          			var d = moment(this.form.fromDate.time);
          			d.add(newVal, "minutes");
          			this.form.toDate = {time: d.format('YYYY-MM-DD HH:mm')};
          		}
        	},
        	"form.toDate": function(newVal, oldVal){
				this.form.duration = Math.abs(moment(this.form.fromDate.time).diff(moment(newVal.time), "minutes"));
        	},
        	"form.fromDate": function(newVal, oldVal){
        		this.form.duration = Math.abs(moment(newVal.time).diff(moment(this.form.toDate.time), "minutes"));
        	}
      	},
		methods: {
			save(){
				if(this.type === "presentation"){
					var presentation = this.form;
					lastDate = _.clone(presentation.toDate.time);
					presentation.fromDate = moment(presentation.fromDate.time).utcOffset(moment().utcOffset()).toDate().toISOString();
					presentation.toDate = moment(presentation.toDate.time).utcOffset(moment().utcOffset()).toDate().toISOString();
					presentation.lecturers = _.map(presentation.lecturers, l => {
						return _.find(this.lecturers, {value: l}).object;
					});
					FirebaseDBService.savePresentation(presentation);
					this.$router.replace({name: 'admin-presentations'});
				}else{
					FirebaseDBService.saveLecturer(this.form);
					this.$router.replace({name: 'admin-lecturers'});
				}
			},
			remove(){
				// TODO: make this work with lecturers too!
				FirebaseDBService.deletePresentation(this.form);
				this.$router.replace({name: 'admin-presentations'});
			},
			removeLecturer(index){
				// FIXME: on empty lecturer, it deletes the whole array!
				this.form.lecturers.splice(index, 1);
				this.$forceUpdate();
			},
			uploadImage(event){
    			var file = event.target.files[0];
    			console.log(file);
    			this.uploading = true;
    			console.log(this.uploading);
    			ConfliveHelperService.uploadImage(file, (err, response) => {
    				this.form.image = response.file;
    				this.uploading = false;
    			})
  			}
		},
		mounted(){
			this.type = this.$route.query.type;
			this.form = initalForm();

			let id = this.$route.query.id;

			if(this.type === "presentation"){

				if(id){
					// Existing presentation or section
					FirebaseDBService.getPresentationById(id, (err, presentation) => {
						presentation.lecturers = presentation.lecturers || [];
						presentation.attachments = presentation.attachments || [];
						presentation.location = presentation.location || {fireId: "l0"};
						presentation.section = presentation.section || " ";
						presentation.lecturers = _.map(presentation.lecturers, l => l.fireId);
						presentation.fromDate = {time: moment(presentation.fromDate).format('YYYY-MM-DD HH:mm')};
						presentation.toDate = {time: moment(presentation.toDate).format('YYYY-MM-DD HH:mm')};
						presentation.isSection = this.$route.query.isSection;
						this.form = presentation;
					});
				}else{
					// New presentation or section
					this.form.isSection = this.$route.query.isSection;
					if(this.form.isSection){
						this.form.displayHours = false;
					}
					if(this.$route.query.parentSection){
						console.log("Called");
						this.form.section = this.$route.query.parentSection;
					}
					console.log("this.form", this.form.section);
					// Initialize new content based on the last save
					if(lastSection){
						this.form.section = lastSection;
					}
					if(lastDate){
						this.form.fromDate = {time: moment(lastDate).format('YYYY-MM-DD HH:mm')};
						this.form.toDate = {time: moment(lastDate).format('YYYY-MM-DD HH:mm')};
					}
				}

				FirebaseDBService.getPresentations((err, presentations) => {
					// Order the potential presentations on the top
					presentations = _.orderBy(presentations, "title");
					// Push default empty presentation too:
					presentations.unshift({
						title: "Nincs megadva",
						fireId: " "
					});
					this.presentations = presentations;
				});

				FirebaseDBService.getLecturers((err, lecturers) => {
					lecturers = _.filter(lecturers, { hidden: false });
        			lecturers = _.sortBy(lecturers, "name");
					this.lecturers = _.map(lecturers, (l) => {
						var row = {
							label: l.name,
							value: l.fireId,
							object: l
						}
						return row;
					});
				});

				FirebaseDBService.getLocations((err, locations) => {
					this.locations = locations;
				});
			}

			if(this.type === "lecturer"){
				if(id){
					FirebaseDBService.getLecturerById(id, (err, lecturer) => {
						lecturer.attachments = lecturer.attachments || [];
						this.form = lecturer;
						this.form.lecturers = [];
					});
				}
			}

		}
	}
</script>

<style scoped>
	.editor .card{
		background-color: #FFF;
		color: #333;
	}

	.actions{
		text-align: right;
	}

	a{
		color: #e3940f;
	}
	.ckeditor {
		margin-top: 2.5em;
		width: 100%;
	}

	.formImage {
		max-width: 200px;
		max-height: 200px;
	}

</style>



// WEBPACK FOOTER //
// EditorView.vue?2aa3e037